/** Geometry for an absolute-positioned line segment between two map points. */
export const formatLine = (
  fromX: number,
  fromY: number,
  toX: number,
  toY: number,
) => {
  const startY = fromY
  const endY = toY
  const startX = fromX
  const endX = toX

  const deltaY = Math.abs(endY - startY)
  const deltaX = Math.abs(endX - startX)
  const lineLength = Math.sqrt(deltaY * deltaY + deltaX * deltaX)

  let angle = (180 / Math.PI) * Math.acos(deltaY / lineLength)

  let midY = (startY - endY) / 2 + endY
  let midX = (startX - endX) / 2 + endX

  if (endY > startY) {
    midY = (endY - startY) / 2 + startY
  }
  if (endX > startX) {
    midX = (endX - startX) / 2 + startX
  }

  if (
    (startY < endY && startX < endX) ||
    (endY < startY && endX < startX) ||
    (startY > endY && startX > endX) ||
    (endY > startY && endX > startX)
  ) {
    angle *= -1
  }

  midY -= lineLength / 2

  return {
    top: midY,
    left: midX,
    height: lineLength,
    rotation: angle,
  }
}
